import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { literalTranslationOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/TrackingPagePreview/constants'

import useBlockSettingOptions from './hooks/useBlockSettingOptions/useBlockSettingOptions'

const BlockSettingSelectField = ({ field, value, onChange }) => {
  const { t } = useTranslation()
  const { options, loadingOptions } = useBlockSettingOptions({ field })

  const handleChange = event => onChange(field.key, event.target.value)

  const menuItems = options.map(option => ({ ...option, label: t(option.label, literalTranslationOptions) }))

  return (
    <ComboBox
      fullWidth
      label={t(field.label, literalTranslationOptions)}
      helperText={t(field.helper, literalTranslationOptions)}
      menuItems={menuItems}
      value={value}
      loading={loadingOptions}
      handleChange={handleChange}
    />
  )
}

export default BlockSettingSelectField
